module.exports = __webpack_public_path__ + "static/media/image-card-3.7f70eaa3.png";